<!--
 * @Author: Gaho
 * @Date: 2024-06-14 10:12:46
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-13 18:49:03
 * @Description: 用户信息弹框-所有游戏卡片
-->
<template>
    <div class="all-games-card">
        <ClientOnly>
            <span class="icon-dice">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20.4 9.8c-.1-1.43-.95-2.3-.95-2.3L14.1 2.53c-1.44-1.14-2.97-.09-2.97-.09L4.06 6.26c-1.24.77-1.05 2.4-1.05 2.4v4.3a6.43 6.43 0 0 0 1.05 3.15l4.97 5.16c1.43 1.53 3.63.19 3.63.19l6.31-3.73c1.34-.76 1.34-2.67 1.34-2.67.19-.77.1-5.26.1-5.26Zm-3.82-2.58c.69 0 1.24.36 1.24.81 0 .45-.55.81-1.24.81s-1.24-.36-1.24-.8c0-.46.55-.82 1.24-.82ZM12.42 3.1c.66 0 1.2.38 1.2.86 0 .47-.54.86-1.2.86-.66 0-1.2-.38-1.2-.86s.54-.86 1.2-.86Zm-.62 3.44c.69 0 1.24.38 1.24.86s-.55.86-1.24.86c-.68 0-1.24-.38-1.24-.86s.56-.86 1.24-.86ZM11.27 10c.72 0 1.3.38 1.3.86 0 .47-.58.86-1.3.86-.7 0-1.28-.39-1.28-.86s.57-.86 1.28-.86ZM7.22 5.98c.63 0 1.14.4 1.14.9s-.51.91-1.14.91c-.64 0-1.15-.4-1.15-.9s.51-.91 1.15-.91ZM3.87 9.22c.27-.1.74.29 1.06.87.32.59.36 1.14.09 1.25-.27.1-.75-.3-1.06-.88-.32-.58-.36-1.14-.1-1.24Zm1.24 6.7c-.27.1-.74-.29-1.06-.87-.31-.59-.35-1.14-.09-1.24.27-.1.75.28 1.07.87.31.58.35 1.14.08 1.24Zm3.92 4.01c-.27.1-.74-.29-1.06-.87-.32-.58-.36-1.14-.09-1.24.27-.1.75.29 1.07.87.31.59.35 1.15.08 1.24Zm-1.2-6.45c.28-.1.75.29 1.07.87.32.59.35 1.14.08 1.24-.27.1-.74-.29-1.06-.87-.31-.59-.35-1.14-.08-1.24Zm8.5 2.89c-.44.52-1.06.73-1.38.45-.33-.27-.23-.9.2-1.43.45-.53 1.06-.73 1.39-.46.32.27.23.91-.21 1.44Z"></path>
                </svg>
            </span>
            <a href="/" target="_blank">
                <ButtonThe3DButton
                    color="blue w-[83px] h-[26px] !text-[11px] !pb-0"
                >
                    All Games
                </ButtonThe3DButton>
            </a>
        </ClientOnly>
    </div>
</template>
<style lang="scss" scoped>
.all-games-card {
    aspect-ratio: .755;
    height: auto;
    align-items: center;
    background-color: var(--color_grey-80);
    border-radius: 14px;
    justify-content: center;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    height: 150px;
    .icon-dice {
        color: rgb(85, 101, 126);
        --7c420739: 60px;
        --36f207c5: none;
        --48d41d34: contain;
        margin-bottom: 12px;
        background-image: var(--36f207c5);
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: var(--48d41d34);
        display: block;
        font-size: var(--7c420739);
        height: var(--7c420739);
        min-height: var(--7c420739);
        min-width: var(--7c420739);
        width: var(--7c420739);
        svg {
            display: block;
            height: var(--7c420739);
            transition: fill .1s ease-in-out;
            width: var(--7c420739);
            fill: rgb(85, 101, 126);
        }
    }
    button {
        :deep(.button-3d__outer) {
            min-height: 100%!important;
            border-radius: 6px !important;
        }
    }
}
</style>
